import React from 'react';
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import { ISelectField } from './interfaces';

export const SelectField: React.FC<ISelectField> = ({
  name,
  label,
  errorMessage,
  children,
  value,
  placeholder,
  onChange,
  disabled,
  required = false,
  error = false,
}): JSX.Element => {
  return (
    <FormControl fullWidth required={required}>
      <InputLabel id={`${name}-select-label`} size="small" error={error}>
        {label}
      </InputLabel>
      <Select
        size="small"
        labelId={`${name}-select-label`}
        value={value ? String(value) : ''}
        label={label}
        onChange={onChange}
        error={error}
        required={required}
        disabled={disabled}
      >
        {placeholder && (
          <MenuItem disabled value="">
            <em>{placeholder}</em>
          </MenuItem>
        )}
        {children}
      </Select>
      {errorMessage && <FormHelperText error>{errorMessage}</FormHelperText>}
    </FormControl>
  );
};
